// 浏览器兼容性检测

export function browserCheck(){
	if(window.openDatabase === undefined){
		return false
	}
	if(window.Promise === undefined){
		return false
	}
	return true
}